@if (useDx()) {
  <dx-button
    [disabled]="disabled"
    [text]="title || ''"
    [icon]="icon || ''"
    [type]="type || ''"
    [stylingMode]="$any(stylingMode())"
    [elementAttr]="dxElementAttr()"
    [ngClass]="{
      'flex-1': dxFlex()
    }"
    (onClick)="onDxClick($event)"
  ></dx-button>
} @else {
  @if (!split) {
    <div
      class="relative flex flex-1 select-none flex-row transition-all overflow-hidden {{
        bgClass || ''
      }} {{ hoverBgClass || '' }}"
      [ngClass]="{
        'bg-slate-50 ': (type === 'default' || type === 'outlined') && !bgClass,
        'bg-slate-700 ': type === 'primary' && !bgClass,
        'border border-slate-100 hover:border-slate-300': type === 'outlined',
        'cursor-pointer': !disabled,
        'cursor-not-allowed opacity-50': disabled,
        'rounded-l-md': !noRoundedLeft && layout === 'default',
        'rounded-r-md': !noRoundedRight && layout === 'default',
        'rounded-md': layout === 'ribbon' || layout === 'top-large-icon',
        'shadow-sm': layout === 'top-large-icon',
        'hover:shadow-md': layout === 'top-large-icon' && !disabled,
        'hover:bg-secondary-100': type === 'secondary-outlined'
      }"
    >
      <!-- loading -->
      @if (loading) {
        <div class="absolute inset-0 flex items-center justify-center">
          <i
            class="fa-light fa-spinner-third animate-spin"
            [ngClass]="{
              'text-lg': !small,
              'text-primary-900': type === 'default' && !textClass,
              'text-slate-100': type === 'primary' && !textClass,
              'text-cyan-700': type === 'text' && !textClass
            }"
          ></i>
        </div>
      }

      <!-- content -->
      <div class="flex flex-row flex-1" [ngClass]="{ invisible: loading }">
        <!-- main content -->
        <div
          (click)="onClickButton($event)"
          [attr.data-track]="trackEvent() || null"
          class="flex items-center flex-1 min-w-0 hover:bg-slate-100"
          [ngClass]="{
            'hover:bg-slate-100': !hoverBgClass,
            'flex-row': layout === 'default',
            'flex-col': layout === 'top-large-icon' || layout === 'ribbon',
            'rounded-l-md': layout === 'default',
            'rounded-r-md': !split && layout === 'default',
            'justify-center': !(!!icon && !!title) && textAlign === 'middle',
            'justify-start': textAlign === 'start',
            'justify-end': textAlign === 'end',
            'gap-2': !small || layout === 'ribbon',
            'px-1 py-1': small && layout === 'default',
            'px-4 py-2': !small && layout === 'default',
            'p-2': layout === 'top-large-icon' || layout === 'ribbon',
            'hover:bg-slate-200':
              (type === undefined ||
                type === 'default' ||
                type === 'outlined' ||
                type === 'text') &&
              !hoverBgClass,
            'hover:bg-slate-900': type === 'primary' && !hoverBgClass,
            'hover:bg-primary-50': type === 'primary-outlined' && !hoverBgClass
          }"
        >
          <!-- icon -->
          @if (icon && !iconStack && type !== "jumbo-snoots-plus") {
            <div
              class="flex items-center justify-center"
              [ngClass]="{
                'w-6': layout === 'default',
                'flex-1': layout === 'top-large-icon'
              }"
            >
              <i
                class="{{ icon }} {{ textClass || '' }}"
                [ngStyle]="iconColor ? { color: iconColor } : null"
                [ngClass]="{
                  'text-xs': small && layout === 'default',
                  'text-lg': !small && layout === 'default',
                  'text-[20px]': layout === 'top-large-icon',
                  'text-xl': layout === 'ribbon',
                  'fa-inverse': type === 'primary',
                  'text-secondary-700': type === 'secondary-outlined',
                  'text-primary-900': type === 'primary-outlined' && !iconColor
                }"
              ></i>
            </div>
          }

          <!-- icon stack -->
          @if (iconStack && icon && type !== "jumbo-snoots-plus") {
            <div>
              <span class="fa-stack fa-2x {{ textClass || '' }}">
                <i class="fa-solid {{ icon }} fa-stack-2x"></i>
                <i class="fab {{ iconStack }} fa-stack-1x fa-inverse"></i>
              </span>
            </div>
          }

          <!-- jumbo -->
          @if (type === "jumbo-snoots-plus") {
            <div class="flex flex-col gap-0 items-center justify-center">
              <div
                style="height: 12px; width: 4px; background-color: #006288"
              ></div>

              <div class="flex flex-row gap-0">
                <div
                  style="height: 4px; width: 14px; background-color: #ff8f86"
                ></div>

                <div
                  style="height: 4px; width: 14px; background-color: #00c5cb"
                ></div>
              </div>

              <div
                style="height: 12px; width: 4px; background-color: #ffaf1b"
              ></div>
            </div>
          }

          <!-- title -->
          @if (title && (layout === "default" || layout === "ribbon")) {
            <div
              [ngClass]="{
                'w-[4.5rem] text-center leading-[0px] flex-1 flex items-center justify-center':
                  layout === 'ribbon',
                'overflow-hidden text-ellipsis whitespace-nowrap':
                  layout !== 'ribbon',
                'text-xs': small && layout !== 'ribbon',
                'text-sm': layout === 'ribbon',
                'text-slate-100': type === 'primary' && !textClass,
                'text-cyan-700': type === 'text' && !textClass,
                'text-primary-900':
                  (type === 'default' && !textClass) ||
                  type === 'primary-outlined',
                'text-secondary-900': type === 'secondary-outlined'
              }"
            >
              @if (html) {
                <span [innerHtml]="title" class="{{ textClass || '' }}"></span>
              }

              @if (!html) {
                <span
                  [innerText]="title"
                  class="{{ textClass || '' }}"
                  [ngClass]="{
                    underline: underline,
                    'text-[10px] font-normal leading-[12px]':
                      layout === 'ribbon'
                  }"
                ></span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (split) {
    <dx-drop-down-button
      [sntTooltip]="splitTooltip"
      [placement]="'top'"
      [splitButton]="true"
      [useSelectMode]="false"
      [text]="title!"
      [disabled]="disabled || false"
      [items]="splitActions() || []"
      class="w-full"
      (onButtonClick)="onClick.emit()"
      (onItemClick)="onSplitItemClick($event)"
    >
    </dx-drop-down-button>
  }
}
